<template>
  <div>
    <section class="blog-area4">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-sm-12">
            <div class="blog-content-wrap">
              <div class="blog-item">
                <div class="blog-img-box">
                    <router-link tag="span" to="/">首页</router-link><span>>{{ title }}</span>
                </div>
                <div class="blog-content">
                  <h3 class="blog__title">{{ article.title }}</h3>
                  <ul class="blog__list">
                    <!-- <li><span class="la la-user"></span><a href="#">{{ article.writer }}</a></li> -->
                    <li><span class="la"></span>
                      {{ article.addtime }}
                    </li>
                    <li style="margin-left:47px;"><span class="la"></span>浏览量：{{ article.artvisits }}</li>
                  </ul>
                  <p class="blog__desc" v-html="article.contentHtml" ref="print">
                  </p>
                  <!-- <div class="tags-item">
                    <ul class="tag__list">
                      <li><span>新闻来源：</span></li>
                      <li v-if="article.source"><a :href="article.source">{{ article.source }}</a></li>
                    </ul>
                    <ul class="social__links">
                      <li @click="print()"><i class="el-icon-printer"></i><span>打印</span></li>
                    </ul>
                  </div> -->
                </div><!-- end blog-content -->
              </div><!-- end blog-post-item -->
            </div><!-- end blog-post-wrapper -->
          </div><!-- end col-md-12-->
        </div><!-- end row -->
      </div><!-- end container -->
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      global,
      article: {},
      title: "文章内容",
      plates:[]
    };
  },

  mounted() {

    let plateId = this.$route.params.plateId;
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.plates = res.data.data;
          for (var i = 0; i < this.plates.length; i++) {
            if (plateId == this.plates[i]._id) {
              this.title = this.plates[i].name;
            }
          }
        }
      });
    let articleId = this.$route.params.articleId;
    if (articleId == "000000") {
      this.$axios.get(`/api/categorys/${plateId}/articles`).then((res) => {
        if (res.data) {
          let articles = res.data.data;
          if (articles.length == 0) return;
          this.$axios.get(`/api/articles/${articles[0]._id}`).then((res) => {
            if (res.data) {
              this.article = res.data.data;
              if (!this.article.addtime) {
                let addtime = this.article.createdAt;
                let date = new Date(addtime);
                this.article.addtime = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)}`
              }
            }
          });
        }
      });
    } else {
      this.$axios.get(`/api/articles/${articleId}`).then((res) => {
        if (res.data) {
          this.article = res.data.data;
          if (!this.article.addtime) {
            let addtime = this.article.createdAt;
            let date = new Date(addtime);
            this.article.addtime = `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)}`
          }
        }
      });
    }
  },

  methods: {
    print() {
      this.$print(this.$refs.print)
    }
  }
}

</script>
<style scoped>
.blog__title{
    height: 48px;
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 22px;
    color: #4462CF;
    line-height: 48px;
    text-align: center;
}
.blog__list{
  height: 50px;
  display: flex;
  justify-content: end;
  color:#BDBDBD;
  border-bottom: 1px solid #EFEFEF;
  line-height: 50px;
}
.blog__desc{
  margin-top: 40px;
}
.blog-img-box{
    height: 60px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
    line-height: 48px;
}
</style>